import axios from 'axios';

export async function getHomeEquityRate(loanType, ltv, creditScore) {
  try {
    return await axios.get(`${process.env.REACT_APP_MCCC_API_URL}/refi/home-equity-rate?loanType=${loanType}&cltv=${ltv}&ficoScore=${creditScore}`);
  } catch (error) {
    console.error(error);
    return error;
  }
}
